// Row counts for the four tabs.
//
// The tab strip previously said nothing about how much was behind each tab, so
// "is anything still queued?" meant clicking through to find out. The server
// does the counting: a page has no way to know how many rows the OTHER tabs
// hold without fetching their lists, which on the Solved tab means shipping the
// whole history to draw a number.
//
// A store rather than a one-shot fetch, because the counts outlive the fetch:
// deleting a job changes a number in a component (TabBar) that knows nothing
// about the delete. Without this the section heading would say "5 jobs" while
// the tab above it still said 6.

import { writable } from "svelte/store";
import { apiFetch } from "./api.js";

/** null until the first successful fetch, and after any failure -- TabBar
 *  renders no badges rather than zeroes, because "0" is a claim and "unknown"
 *  is the truth. */
export const counts = writable(null);

export async function refreshCounts() {
  try {
    const body = await apiFetch("/file/counts");
    counts.set(body.counts);
  } catch {
    // Badges are additive. Losing them is not worth surfacing to the user.
    counts.set(null);
  }
}
